import { Routes } from '@angular/router';
import {
  adminGuard, agentGuard, authGuard, changePasswordGuard,
  loginGuard, touGuard, acceptTermsGuard,
} from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: 'login',
    canActivate: [loginGuard],
    loadComponent: () => import('./features/auth/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'change-password',
    canActivate: [changePasswordGuard],
    loadComponent: () =>
      import('./features/auth/change-password/change-password.component').then((m) => m.ChangePasswordComponent),
  },
  {
    path: 'accept-terms',
    canActivate: [acceptTermsGuard],
    loadComponent: () =>
      import('./features/auth/accept-terms/accept-terms.component').then((m) => m.AcceptTermsComponent),
  },
  {
    path: 'agent',
    canActivate: [authGuard, touGuard, agentGuard],
    loadChildren: () => import('./features/agent/agent.routes').then((m) => m.agentRoutes),
  },
  {
    path: 'admin',
    canActivate: [authGuard, touGuard, adminGuard],
    loadChildren: () => import('./features/admin/admin.routes').then((m) => m.adminRoutes),
  },
  {
    path: 'field',
    canActivate: [authGuard, touGuard, adminGuard],
    children: [
      {
        path: 'new-visit',
        loadComponent: () => import('./features/agent/new-visit/new-visit.component').then(m => m.NewVisitComponent),
      },
      {
        path: 'visit/:visitId',
        loadComponent: () => import('./features/agent/visit/visit.component').then(m => m.VisitComponent),
      },
      {
        path: 'visit/:visitId/link/:photoId',
        loadComponent: () => import('./features/agent/link-photo/link-photo.component').then(m => m.LinkPhotoComponent),
      },
      {
        path: 'visit/:visitId/conflict/:itemId',
        loadComponent: () => import('./features/agent/conflict-resolution/conflict-resolution.component').then(m => m.ConflictResolutionComponent),
      },
      {
        path: 'survey',
        loadComponent: () => import('./features/agent/surveys/survey-list.component').then(m => m.SurveyListComponent),
      },
      {
        path: 'survey-history',
        loadComponent: () => import('./features/agent/survey-history/survey-history-pos-list/survey-history-pos-list.component').then(m => m.SurveyHistoryPosListComponent),
      },
      {
        path: 'survey-history/:storeId',
        loadComponent: () => import('./features/agent/survey-history/survey-history-survey-list/survey-history-survey-list.component').then(m => m.SurveyHistorySurveyListComponent),
      },
      {
        path: 'survey-history/:storeId/:surveyId',
        loadComponent: () => import('./features/agent/survey-history/survey-history-submissions-list/survey-history-submissions-list.component').then(m => m.SurveyHistorySubmissionsListComponent),
      },
      {
        path: 'survey/:surveyId',
        loadComponent: () => import('./features/agent/surveys/survey-detail.component').then(m => m.SurveyDetailComponent),
      },
      {
        path: 'survey/:surveyId/pos',
        loadComponent: () => import('./features/agent/surveys/survey-pos-list.component').then(m => m.SurveyPosListComponent),
      },
      {
        path: 'survey/:surveyId/compile',
        loadComponent: () => import('./features/agent/surveys/survey-compile/survey-compile.component').then(m => m.SurveyCompileComponent),
      },
      {
        path: 'survey/:surveyId/:storeId',
        loadComponent: () => import('./features/agent/surveys/survey-detail.component').then(m => m.SurveyDetailComponent),
      },
      {
        path: 'survey/:surveyId/:storeId/compile',
        loadComponent: () => import('./features/agent/surveys/survey-compile/survey-compile.component').then(m => m.SurveyCompileComponent),
      },
    ],
  },
  { path: '**', redirectTo: '/login' },
];
